import Link from 'next/link';

const RenderedLink = ({ link, title }: { link: string; title: string }) => (
  <Link href={link} className="flex items-center capitalize">
    <span className="text-gray-700/50 underline underline-offset-1 transition duration-150 ease-in-out hover:text-gray-700/100">
      {title}
    </span>
  </Link>
);

export default RenderedLink;
